import React from "react";
import { motion } from "framer-motion";

import nitdaLogo from "../../../images/partnership/cropped-cropped-NITDA-Logo-new-03 1 (1).png";
import techcabalLogo from "../../../images/partnership/tc-logo-3-300x67-1 1 (1).png";
import vanguardLogo from "../../../images/partnership/Vanguard_Nigeria_logo.svg 1 (1).png";

const SectionSeven = () => {
    return (
        <section className="py-24 px-6 md:px-12 bg-white flex flex-col items-center justify-center text-center">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                <h3 className="text-[#ef8702] font-extrabold text-base">
                    Partnerships & Media
                </h3>
                <h2 className="mt-4 text-3xl md:text-5xl font-bold text-black tracking-tight">
                    NKENNEAi Is Trusted By & Featured In
                </h2>
                <p className="mt-4 text-gray-700 max-w-3xl mx-auto text-base">
                    We are collaborating with credible institutions and recognised across respected media platforms
                </p>
            </motion.div>

            <div className="mt-16 flex flex-col md:flex-row items-center justify-center gap-16 md:gap-36 w-full max-w-5xl mx-auto">
                <motion.img
                    src={nitdaLogo}
                    alt="NITDA"
                    className="h-10 md:h-12 object-contain mix-blend-multiply"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    viewport={{ once: true }}
                />
                <motion.img
                    src={techcabalLogo}
                    alt="TechCabal"
                    className="h-6 md:h-8 object-contain mix-blend-multiply"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    viewport={{ once: true }}
                />
                <motion.img
                    src={vanguardLogo}
                    alt="Vanguard"
                    className="h-6 md:h-8 object-contain mix-blend-multiply"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.6 }}
                    viewport={{ once: true }}
                />
            </div>
        </section>
    );
};

export default SectionSeven;
